import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Typography, Button, Icon } from '@packages/ui/shared';

const useConfirmDeleteAssetModalStyles = createUseStyles({
    changeConactModal: {
        width: 558,
        maxWidth: 'none',
    },
});

interface ChangeContactModalProps {
    show: boolean;
    onConfirm(): void;
    onHide(): void;
    isLoading?: boolean;
}

const ConfirmDeleteAssetModal: FC<ChangeContactModalProps> = ({ onConfirm, onHide, ...props }) => {
    const classes = useConfirmDeleteAssetModalStyles();
    const { t } = useTranslation();

    return (
        <Modal show={props.show} dialogClassName={classes.changeConactModal} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Typography variant="h4">{t('modals:deleteAsset.title', 'Delete Attachment?')}</Typography>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex">
                    <Icon name="warning" />
                    <div className="d-flex flex-column ml-3">
                        <Typography variant="h5" style={{ marginBottom: 10 }}>
                            {t('modals:deleteAsset.message', 'Are you sure you want to delete this attachment?')}
                        </Typography>
                        <Typography variant="lead">
                            {t('modals:deleteAsset.hint', 'Deleting attachments cannot be undone.')}
                        </Typography>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button title={t('modals:deleteAsset.cancel', 'Cancel')} variant="link" onPress={onHide} />
                <Button
                    title={t('modals:deleteAsset.confirm', 'Delete')}
                    variant="danger"
                    onPress={onConfirm}
                    style={{ marginLeft: 20 }}
                    isLoading={props.isLoading}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDeleteAssetModal;
